export default __webpack_public_path__ + "static/media/seedlings.e8119ab6.jpg";